<template>
  <div class="px-4 py-4 sm:px-6 main-container">
    <div class="h-full">
      <div class="flex flex-col h-full md:flex-row">
        <div class="flex-1">
          <div
            class="relative text-lg font-medium leading-6 text-gray-900 pb-0.5"
          >
            <span class="inline-flex py-2"
              >{{ patient.first_name }} {{ patient.last_name }}</span
            >
            <span class="absolute right-0 inline-flex rounded-md shadow-sm">
              <button
                @click="save"
                type="button"
                class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
              >
                Salva
              </button>
            </span>
          </div>
          <div class="w-full py-4 border-t border-gray-200 scrollable md:px-6">
            <div class="grid grid-cols-6 gap-3">
              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="name"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Nome</label
                >
                <input
                  id="name"
                  v-model="patient.first_name"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="last_name"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Cognome</label
                >
                <input
                  id="last_name"
                  v-model="patient.last_name"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-4">
                <label
                  for="email_address"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Indirizzo Email</label
                >
                <input
                  id="email_address"
                  v-model="patient.email"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="phone"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Telefono</label
                >
                <input
                  id="phone"
                  v-model="patient.phone"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="mobile"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Mobile</label
                >
                <input
                  id="mobile"
                  v-model="patient.mobile"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6">
                <label
                  for="street_address"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Indirizzo</label
                >
                <input
                  id="street_address"
                  v-model="patient.address"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-6 lg:col-span-2">
                <label
                  for="city"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Città</label
                >
                <input
                  id="city"
                  v-model="patient.city"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                  @focusout="city"
                />
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="state"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Provincia</label
                >
                <input
                  id="state"
                  v-model="patient.province"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="postal_code"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >CAP</label
                >
                <input
                  id="postal_code"
                  v-model="patient.zip"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="birthplace"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Luogo Nascita</label
                >
                <input
                  id="birthplace"
                  v-model="patient.birthplace"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                  @focusout="birthplace"
                />
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="gender"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Sesso</label
                >
                <select
                  id="gender"
                  v-model="patient.gender"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm form-select focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                >
                  <option value=""></option>
                  <option value="M">Maschio</option>
                  <option value="F">Femmina</option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="dob"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Data di Nascita</label
                >
                <flat-pickr
                  id="dob"
                  v-model="patient.dob"
                  :config="config"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                >
                </flat-pickr>
              </div>

              <div class="col-span-6 sm:col-span-3 lg:col-span-2">
                <label
                  for="cf"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Codice Fiscale</label
                >
                <input
                  id="cf"
                  v-model="patient.cf"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                  @focus="cf"
                />
              </div>

              <div class="col-span-6">
                <label
                  for="notes"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Note</label
                >
                <textarea
                  id="notes"
                  :rows="notesRows"
                  @focus="notesRows = expandedRows"
                  @blur="notesRows = defaultRows"
                  v-model="patient.notes"
                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <patient-examination-list
          v-if="patient.id"
          class="flex-1"
        ></patient-examination-list>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.scrollable {
  height: calc(100% - 36px);
}
</style>

<script>
import { mapState } from "vuex";
import { Italian } from "flatpickr/dist/l10n/it";
import CodiceFiscale from "calcolo-codice-fiscale";
import PatientExaminationList from "./PatientExaminationsList";

export default {
  props: {
    id: {
      required: false,
    },
  },

  data: () => {
    return {
      loaded: false,
      config: {
        altFormat: "d/m/Y",
        altInput: true,
        dateFormat: "Y-m-d",
        locale: Italian,
        allowInput: true,
      },
      notesRows: 3,
      expandedRows: 10,
      defaultRows: 3,
    };
  },

  components: {
    PatientExaminationList,
  },

  computed: {
    ...mapState("patient", ["patient"]),
    ...mapState("app", ["user", "cities"]),
  },

  methods: {
    city() {
      if (this.patient.city) {
        let city = this.cities.find((element) => {
          return element.nome.toUpperCase() == this.patient.city.toUpperCase();
        });
        this.patient.province = city.sigla;
        this.patient.zip = city.cap[0];
      }
    },
    birthplace() {
      if (this.patient.birthplace) {
        let city = this.cities.find((element) => {
          return (
            element.nome.toUpperCase() == this.patient.birthplace.toUpperCase()
          );
        });
        this.patient.birthplace_province = city.sigla;
      }
    },
    cf() {
      let dob = window.moment(this.patient.dob);
      let cf = CodiceFiscale.compute(
        this.patient.first_name,
        this.patient.last_name,
        this.patient.gender,
        dob.date(),
        dob.month() + 1,
        dob.year(),
        this.patient.birthplace,
        this.patient.birthplace_province
      );
      this.patient.cf = cf;
    },
    save() {
      this.$store.dispatch("patient/SAVE", this.patient);
    },
    destroy() {
      if (confirm("Sicuro di voler cancellare il paziente?")) {
        this.$store.dispatch("patient/DELETE");
        this.$router.go(-1);
      }
    },
  },
};
</script>
